const ChatbotTab = {
  CHATS: "chats",
  EMBED: "embed",
  TRAIN: "train",
  ANALYTICS: "analytics",
  PLAYGROUND: "playground",
};

export default ChatbotTab;
